function Button({ text, onClick, color = "bg-blue-600" }) {
  return (
    <button
      onClick={onClick}
      className={`${color} text-white px-4 py-2 dark:bg-blue-600 rounded hover:opacity-80 transition`}
    >
      {" "}
      {text}{" "}
    </button>
  );
}
export default Button;
